import React from "react";
// import { NavbarBorrowSystem } from "../../../../components/share/NavbarBorrowSystem";
import { NavbarBorrowSystem } from '../../../components/share/NavbarBorrowSystem';
import { HeadTitle } from "../../../components/share/HeadTitle";
import { JobPositionFormTestComponent } from "../../../components/borrowSystem/BorrowForm/JobPositionFormTestComponent";
import { Footer } from "../../../components/share/Footer";

export function JobPositionFormTestContainer() {
  const titleName =
    "รายละเอียดการขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานเพื่อดำเนินการทดสอบมาตรฐานฝีมือแรงงาน";

  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <JobPositionFormTestComponent />
      <Footer />
    </div>
  );
}
